<template>
  <div>
    <section class="mb-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0">Perizinan <span class="text-danger">*</span></h5>
        <b-button size="sm" variant="primary" @click="tambahPerizinan">
          <i class="fa fa-plus"></i> Tambah Perizinan
        </b-button>
      </div>

      <b-card v-for="(izin, index) in value.perizinan" :key="izin.id" class="mb-3">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0">Perizinan {{ index + 1 }}</h6>
          <b-button
            v-if="value.perizinan.length > 1"
            size="sm"
            variant="danger"
            class="text-white"
            @click="hapusPerizinan(izin.id)"
          >
            <i class="fa fa-trash"></i> Hapus
          </b-button>
        </div>
        <b-row>
          <b-col md="6">
            <b-form-group :label-for="`kategori-izin-${izin.id}`">
              <template #label>Kategori <span class="text-danger">*</span></template>
              <b-form-select
                :id="`kategori-izin-${izin.id}`"
                :value="izin.kategori"
                :options="kategoriOptions"
                class="form-control"
                @change="updatePerizinan(izin.id, 'kategori', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`nama-izin-${izin.id}`">
              <template #label>Nama Izin <span class="text-danger">*</span></template>
              <b-form-input
                :id="`nama-izin-${izin.id}`"
                :value="izin.nama_izin"
                type="text"
                @input="updatePerizinan(izin.id, 'nama_izin', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`nomor-izin-${izin.id}`">
              <template #label>Nomor Izin <span class="text-danger">*</span></template>
              <b-form-input
                :id="`nomor-izin-${izin.id}`"
                :value="izin.nomor_izin"
                type="text"
                @input="updatePerizinan(izin.id, 'nomor_izin', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`tanggal-terbit-izin-${izin.id}`">
              <template #label>Tanggal Terbit <span class="text-danger">*</span></template>
              <b-form-input
                :id="`tanggal-terbit-izin-${izin.id}`"
                :value="izin.tanggal_terbit"
                type="date"
                @input="updatePerizinan(izin.id, 'tanggal_terbit', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`masa-berlaku-izin-${izin.id}`">
              <template #label>Masa Berlaku <span class="text-danger">*</span></template>
              <b-input-group append="tahun">
                <b-form-input
                  :id="`masa-berlaku-izin-${izin.id}`"
                  :value="izin.masa_berlaku"
                  type="number"
                  min="1"
                  placeholder="Contoh: 20"
                  @input="updatePerizinan(izin.id, 'masa_berlaku', $event)"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </section>

    <b-row>
      <b-col md="6">
        <b-form-group label-for="jenis-area">
          <template #label>Jenis Area <span class="text-danger">*</span></template>
          <b-form-select
            id="jenis-area"
            :value="value.jenis_area"
            :options="jenisAreaOptions"
            class="form-control"
            @change="updateField('jenis_area', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <section class="mb-4 mt-4">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h5 class="mb-0">Koordinat Perizinan Berusaha <span class="text-danger">*</span></h5>
        <div>
          <b-button variant="primary" size="sm" class="mr-2" @click="tambahKoordinat">
            <i class="fa fa-plus"></i> Tambah Titik
          </b-button>
          <b-button variant="primary" size="sm" @click="showImportModal = true">
            <i class="fa fa-upload"></i> Import Koordinat
          </b-button>
        </div>
      </div>

      <template v-if="value.koordinat_perizinan.length">
        <div class="table-responsive mb-0 datatables">
          <b-table striped hover :items="itemsWithNumber" :fields="fields" responsive="sm">
            <template #cell(bujur)="data">
              <b-form-input
                :value="data.item.bujur"
                type="text"
                :aria-label="`Bujur titik ${data.item.nomor}`"
                @input="updateKoordinat(data.item.id, 'bujur', $event)"
              />
            </template>
            <template #cell(lintang)="data">
              <b-form-input
                :value="data.item.lintang"
                type="text"
                :aria-label="`Lintang titik ${data.item.nomor}`"
                @input="updateKoordinat(data.item.id, 'lintang', $event)"
              />
            </template>
            <template #cell(aksi)="data">
              <b-button size="sm" variant="danger" class="text-white" @click="hapusKoordinat(data.item.id)">
                <i class="fa fa-trash"></i> Hapus
              </b-button>
            </template>
          </b-table>
        </div>
        <p v-if="previewError" class="text-danger mb-2">{{ previewError }}</p>
        <div v-if="geometryIsValid" class="mb-2">
          <template v-if="value.jenis_area === 'Luas'">
            Luas area: <strong>{{ formattedArea }} ha</strong>
          </template>
          <template v-else>
            Panjang area: <strong>{{ formattedLength }} m</strong>
          </template>
        </div>
        <div v-if="geometryIsValid && isActive" class="coordinate-map mb-3">
          <l-map :zoom="mapZoom" :center="mapCenter" :options="mapOptions" @ready="onMapReady">
            <l-tile-layer :url="tileUrl" />
            <l-polygon
              v-if="value.jenis_area === 'Luas'"
              :lat-lngs="polygonLatLngs"
              :color="'#1769aa'"
              :fill-opacity="0.35"
            />
            <l-polyline v-else :lat-lngs="polygonLatLngs" :color="'#1769aa'" :weight="4" />
          </l-map>
        </div>
      </template>
      <p v-else class="text-muted">Import file Excel untuk menampilkan koordinat dan preview area.</p>
    </section>

    <b-modal v-model="showImportModal" title="Import Koordinat Perizinan" hide-footer @hidden="resetImport" scrollable>
      <template>
        <b-form-group label-for="koordinat-perizinan-file">
          <template #label>File Excel <span class="text-danger">*</span></template>
          <b-form-file
            id="koordinat-perizinan-file"
            v-model="importFile"
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            placeholder="Pilih file Excel"
            drop-placeholder="Letakkan file Excel di sini"
            plain
            class="form-control"
          />
        </b-form-group>
        <b-alert show variant="warning">
          Import koordinat akan menimpa data titik koordinat lama.
        </b-alert>
        <b-alert v-if="importError" show variant="danger">{{ importError }}</b-alert>
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-2" @click="showImportModal = false">Batal</b-button>
          <b-button variant="primary" :disabled="!importFile || isImporting" @click="importCoordinates">
            {{ isImporting ? 'Memproses...' : 'Import' }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div>
        <b-button variant="success" class="mr-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'
import { LMap, LTileLayer, LPolygon, LPolyline } from 'vue2-leaflet'
import api from '@/services/api'

const EARTH_RADIUS_METERS = 6371008.8

export default {
  name: 'FormKemajuanPerizinanPusat',
  components: { LMap, LTileLayer, LPolygon, LPolyline },
  props: {
    isActive: { type: Boolean, default: true },
    value: {
      type: Object,
      default: () => ({
        perizinan: [{ id: 1, kategori: '', nama_izin: '', nomor_izin: '', tanggal_terbit: '', masa_berlaku: '' }],
        jenis_area: '',
        koordinat_perizinan: [],
      }),
    },
  },
  data() {
    return {
      kategoriOptions: [
        { value: '', text: 'Pilih Kategori' },
        { value: 'Persetujuan Lingkungan', text: 'Persetujuan Lingkungan' },
        { value: 'Perizinan Berusaha/Nonberusaha', text: 'Perizinan Berusaha/Nonberusaha' },
        { value: 'Perizinan Lainnya', text: 'Perizinan Lainnya' },
      ],
      jenisAreaOptions: [
        { value: '', text: 'Pilih Jenis Area' },
        { value: 'Luas', text: 'Luas' },
        { value: 'Panjang', text: 'Panjang' },
      ],
      showImportModal: false,
      importFile: null,
      importError: '',
      isImporting: false,
      isSaving: false,
      nextPointId: 1,
      nextPerizinanId: 1,
      savedPerizinanById: {},
      savedKoordinatById: {},
      tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      mapZoom: 5,
      mapOptions: { zoomControl: true, scrollWheelZoom: false },
      fields: [
        { key: 'nomor', label: 'No' },
        { key: 'bujur', label: 'Bujur' },
        { key: 'lintang', label: 'Lintang' },
        { key: 'aksi', label: 'Aksi' },
      ],
    }
  },
  computed: {
    idPelaksanaanPenilaian() {
      return this.$route.query.id_pelaksanaan_penilaian || ''
    },
    itemsWithNumber() {
      return this.value.koordinat_perizinan.map((point, index) => ({ ...point, nomor: index + 1 }))
    },
    coordinatesAreInRange() {
      const minimumPoints = this.value.jenis_area === 'Luas' ? 3 : 2
      return (
        ['Luas', 'Panjang'].includes(this.value.jenis_area) &&
        this.value.koordinat_perizinan.length >= minimumPoints &&
        this.value.koordinat_perizinan.every((point) => this.isCoordinateInRange(point))
      )
    },
    polygonLatLngs() {
      return this.value.koordinat_perizinan.map((point) => [Number(point.lintang), Number(point.bujur)])
    },
    mapCenter() {
      if (!this.polygonLatLngs.length) return [0, 0]
      const totals = this.polygonLatLngs.reduce((sum, point) => [sum[0] + point[0], sum[1] + point[1]], [0, 0])
      return [totals[0] / this.polygonLatLngs.length, totals[1] / this.polygonLatLngs.length]
    },
    polygonAreaSquareMeters() {
      if (!this.coordinatesAreInRange || new Set(this.polygonLatLngs.map((point) => point.join(','))).size < 3) return 0
      let areaSum = 0
      this.polygonLatLngs.forEach((point, index) => {
        const next = this.polygonLatLngs[(index + 1) % this.polygonLatLngs.length]
        const latitude = (point[0] * Math.PI) / 180
        const nextLatitude = (next[0] * Math.PI) / 180
        let longitudeDifference = ((next[1] - point[1]) * Math.PI) / 180
        if (longitudeDifference > Math.PI) longitudeDifference -= 2 * Math.PI
        if (longitudeDifference < -Math.PI) longitudeDifference += 2 * Math.PI
        areaSum += longitudeDifference * (2 + Math.sin(latitude) + Math.sin(nextLatitude))
      })
      return Math.abs((areaSum * EARTH_RADIUS_METERS * EARTH_RADIUS_METERS) / 2)
    },
    polygonIsValid() {
      return this.value.jenis_area === 'Luas' && this.coordinatesAreInRange && this.polygonAreaSquareMeters > 0
    },
    polylineLengthMeters() {
      if (this.value.jenis_area !== 'Panjang' || !this.coordinatesAreInRange) return 0
      let distance = 0
      this.value.koordinat_perizinan.slice(1).forEach((point, index) => {
        const previous = this.value.koordinat_perizinan[index]
        const toRadians = (degree) => (degree * Math.PI) / 180
        const latitudeDifference = toRadians(Number(point.lintang) - Number(previous.lintang))
        const longitudeDifference = toRadians(Number(point.bujur) - Number(previous.bujur))
        const latitude1 = toRadians(Number(previous.lintang))
        const latitude2 = toRadians(Number(point.lintang))
        const haversine =
          Math.sin(latitudeDifference / 2) ** 2 +
          Math.cos(latitude1) * Math.cos(latitude2) * Math.sin(longitudeDifference / 2) ** 2
        distance += 2 * EARTH_RADIUS_METERS * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
      })
      return distance
    },
    polylineIsValid() {
      return this.value.jenis_area === 'Panjang' && this.coordinatesAreInRange && this.polylineLengthMeters > 0
    },
    geometryIsValid() {
      return this.value.jenis_area === 'Luas' ? this.polygonIsValid : this.polylineIsValid
    },
    previewError() {
      if (!['Luas', 'Panjang'].includes(this.value.jenis_area))
        return 'Pilih jenis area untuk menampilkan preview dan hasil pengukuran.'
      const minimumPoints = this.value.jenis_area === 'Luas' ? 3 : 2
      const geometryName = this.value.jenis_area === 'Luas' ? 'Polygon' : 'Polyline'
      if (this.value.koordinat_perizinan.length < minimumPoints) {
        return `${geometryName} memerlukan minimal ${minimumPoints} titik koordinat.`
      }
      if (!this.coordinatesAreInRange)
        return 'Lengkapi Bujur dan Lintang yang valid. Bujur antara -180 dan 180, serta Lintang antara -90 dan 90.'
      if (this.value.jenis_area === 'Luas' && this.polygonAreaSquareMeters <= 0)
        return 'Titik koordinat tidak membentuk polygon dengan luasan.'
      if (this.value.jenis_area === 'Panjang' && this.polylineLengthMeters <= 0)
        return 'Titik koordinat tidak membentuk polyline dengan panjang.'
      return ''
    },
    formattedArea() {
      return (this.polygonAreaSquareMeters / 10000).toLocaleString('id-ID', { maximumFractionDigits: 4 })
    },
    formattedLength() {
      return this.polylineLengthMeters.toLocaleString('id-ID', { maximumFractionDigits: 2 })
    },
  },
  mounted() {
    this.syncSnapshotFromValue()
  },
  methods: {
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    syncSnapshotFromValue(data) {
      const source = data || this.value
      const perizinan = source.perizinan || []
      const koordinat = source.koordinat_perizinan || []

      this.savedPerizinanById = perizinan.reduce((result, izin) => {
        result[izin.id] = { ...izin }
        return result
      }, {})
      this.savedKoordinatById = koordinat.reduce((result, point) => {
        result[point.id] = { ...point }
        return result
      }, {})

      this.nextPerizinanId = perizinan.reduce((maxId, izin) => Math.max(maxId, Number(izin.id) || 0), 0) + 1
      this.nextPointId = koordinat.reduce((maxId, point) => Math.max(maxId, Number(point.id) || 0), 0) + 1
    },
    isCoordinateFilled(point) {
      const bujur = String(point.bujur === null || point.bujur === undefined ? '' : point.bujur).trim()
      const lintang = String(point.lintang === null || point.lintang === undefined ? '' : point.lintang).trim()
      return bujur !== '' && lintang !== ''
    },
    isCoordinateInRange(point) {
      return (
        this.isCoordinateFilled(point) &&
        Number.isFinite(Number(point.bujur)) &&
        Number(point.bujur) >= -180 &&
        Number(point.bujur) <= 180 &&
        Number.isFinite(Number(point.lintang)) &&
        Number(point.lintang) >= -90 &&
        Number(point.lintang) <= 90
      )
    },
    tambahPerizinan() {
      const izin = {
        id: this.nextPerizinanId++,
        kategori: '',
        nama_izin: '',
        nomor_izin: '',
        tanggal_terbit: '',
        masa_berlaku: '',
      }
      this.$emit('input', { ...this.value, perizinan: [...this.value.perizinan, izin] })
    },
    updatePerizinan(id, field, fieldValue) {
      const perizinan = this.value.perizinan.map((izin) => (izin.id === id ? { ...izin, [field]: fieldValue } : izin))
      this.$emit('input', { ...this.value, perizinan })
    },
    async hapusPerizinan(id) {
      if (this.value.perizinan.length <= 1) return

      if (this.savedPerizinanById[id]) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Hapus Perizinan?',
          text: 'Perizinan yang dihapus tidak dapat dikembalikan.',
          showCancelButton: true,
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal',
        })
        if (!result.isConfirmed) return

        try {
          await api.delete(`api/kemajuan_perizinan/${id}`)
          this.$delete(this.savedPerizinanById, id)
        } catch (error) {
          const message = error.response?.data?.message || 'Gagal menghapus perizinan'
          Swal.fire('Gagal', message, 'error')
          return
        }
      }

      this.$emit('input', {
        ...this.value,
        perizinan: this.value.perizinan.filter((izin) => izin.id !== id),
      })
    },
    hasPerizinanChanged(izin) {
      const saved = this.savedPerizinanById[izin.id]
      if (!saved) return true

      return (
        saved.kategori !== izin.kategori ||
        saved.nama_izin !== izin.nama_izin ||
        saved.nomor_izin !== izin.nomor_izin ||
        saved.tanggal_terbit !== izin.tanggal_terbit ||
        String(saved.masa_berlaku) !== String(izin.masa_berlaku)
      )
    },
    hasKoordinatChanged(point, index) {
      const saved = this.savedKoordinatById[point.id]
      if (!saved) return true

      return (
        String(saved.nama_titik) !== String(index + 1) ||
        String(saved.bujur) !== String(point.bujur) ||
        String(saved.lintang) !== String(point.lintang)
      )
    },
    isPerizinanComplete() {
      return this.value.perizinan.every((izin) => {
        const masaBerlaku = Number(izin.masa_berlaku)
        return (
          String(izin.kategori || '').trim() !== '' &&
          String(izin.nama_izin || '').trim() !== '' &&
          String(izin.nomor_izin || '').trim() !== '' &&
          String(izin.tanggal_terbit || '').trim() !== '' &&
          Number.isFinite(masaBerlaku) &&
          masaBerlaku > 0
        )
      })
    },
    async simpanJenisArea(id) {
      const formData = new FormData()
      formData.append('jenis_area', this.value.jenis_area)
      await api.post(`api/pelaksanaan_penilaian/${id}`, formData)
    },
    async simpanPerizinan(id) {
      for (const izin of this.value.perizinan) {
        if (!this.hasPerizinanChanged(izin)) continue

        const payload = {
          id_pelaksanaan_penilaian: id,
          kategori: izin.kategori,
          nama_izin: izin.nama_izin,
          nomor_izin: izin.nomor_izin,
          tanggal_terbit: izin.tanggal_terbit,
          masa_berlaku: Number(izin.masa_berlaku),
        }

        if (this.savedPerizinanById[izin.id]) {
          await api.put(`api/kemajuan_perizinan/${izin.id}`, payload)
        } else {
          await api.post('api/kemajuan_perizinan', payload)
        }
      }
    },
    async simpanKoordinatPerizinan(id) {
      const points = this.value.koordinat_perizinan || []
      const currentIds = points.map((point) => point.id)
      const deletedIds = Object.keys(this.savedKoordinatById).filter(
        (savedId) => !currentIds.includes(Number(savedId)),
      )

      for (const deletedId of deletedIds) {
        await api.delete(`api/koordinat_perizinan_berusaha/${deletedId}`)
      }

      for (const [index, point] of points.entries()) {
        if (!this.hasKoordinatChanged(point, index)) continue

        const payload = {
          id_pelaksanaan_penilaian: id,
          nama_titik: String(index + 1),
          bujur: String(point.bujur),
          lintang: String(point.lintang),
        }

        if (this.savedKoordinatById[point.id]) {
          await api.put(`api/koordinat_perizinan_berusaha/${point.id}`, payload)
        } else {
          await api.post('api/koordinat_perizinan_berusaha', payload)
        }
      }
    },
    async simpanKemajuanPerizinan() {
      const id = this.idPelaksanaanPenilaian
      if (!id) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      if (!['Luas', 'Panjang'].includes(this.value.jenis_area)) {
        Swal.fire('Belum Lengkap', 'Pilih Jenis Area terlebih dahulu.', 'warning')
        return false
      }

      if (!this.isPerizinanComplete()) {
        Swal.fire('Belum Lengkap', 'Lengkapi seluruh data perizinan terlebih dahulu.', 'warning')
        return false
      }

      if (!this.geometryIsValid) {
        Swal.fire('Belum Lengkap', 'Titik koordinat belum valid untuk jenis area yang dipilih.', 'warning')
        return false
      }

      this.isSaving = true
      try {
        await this.simpanJenisArea(id)
        await this.simpanPerizinan(id)
        await this.simpanKoordinatPerizinan(id)
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan kemajuan perizinan'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.isSaving = false
      }
    },
    tambahKoordinat() {
      const point = { id: this.nextPointId++, nama_titik: '', bujur: '', lintang: '' }
      this.$emit('input', { ...this.value, koordinat_perizinan: [...this.value.koordinat_perizinan, point] })
    },
    updateKoordinat(id, field, fieldValue) {
      const koordinat_perizinan = this.value.koordinat_perizinan.map((point) =>
        point.id === id ? { ...point, [field]: fieldValue } : point,
      )
      this.$emit('input', { ...this.value, koordinat_perizinan })
    },
    async hapusKoordinat(id) {
      const point = this.value.koordinat_perizinan.find((item) => item.id === id)
      if (!point) return

      if (this.savedKoordinatById[id]) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Hapus Titik Koordinat?',
          text: 'Titik koordinat yang dihapus tidak dapat dikembalikan.',
          showCancelButton: true,
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal',
        })
        if (!result.isConfirmed) return

        try {
          await api.delete(`api/koordinat_perizinan_berusaha/${id}`)
          this.$delete(this.savedKoordinatById, id)
        } catch (error) {
          const message = error.response?.data?.message || 'Gagal menghapus titik koordinat'
          Swal.fire('Gagal', message, 'error')
          return
        }
      }

      this.$emit('input', {
        ...this.value,
        koordinat_perizinan: this.value.koordinat_perizinan.filter((item) => item.id !== id),
      })
    },
    resetImport() {
      this.importFile = null
      this.importError = ''
      this.isImporting = false
    },
    async importCoordinates() {
      if (!this.importFile) {
        this.importError = 'Pilih file Excel terlebih dahulu.'
        return
      }
      if (!['Luas', 'Panjang'].includes(this.value.jenis_area)) {
        this.importError = 'Pilih Jenis Area sebelum mengimpor koordinat.'
        return
      }

      const confirmation = await Swal.fire({
        icon: 'warning',
        title: 'Import Koordinat',
        text: 'Import koordinat akan menimpa data titik koordinat lama, termasuk perubahan yang belum disimpan.',
        showCancelButton: true,
        confirmButtonText: 'Ya, Import',
        cancelButtonText: 'Batal',
      })
      if (!confirmation.isConfirmed) return

      this.isImporting = true
      this.importError = ''
      try {
        const workbook = XLSX.read(await this.importFile.arrayBuffer(), { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        if (!firstSheetName) throw new Error('File Excel tidak memiliki sheet untuk dibaca.')

        const rows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], { header: 1, defval: '' })
        if (rows.length < 2) throw new Error('File Excel harus memiliki header dan minimal satu baris data.')

        const columns = this.getCoordinateColumnIndexes(rows[0])
        if (Object.values(columns).some((index) => index === -1)) {
          throw new Error('Header wajib: No, Nama Titik, Bujur, dan Lintang.')
        }

        const importedPoints = []
        rows.slice(1).forEach((row, index) => {
          const nomor = String(row[columns.nomor] || '').trim()
          const namaTitik = String(row[columns.namaTitik] || '').trim()
          const bujur = String(row[columns.bujur] || '').trim()
          const lintang = String(row[columns.lintang] || '').trim()
          if (!nomor && !namaTitik && !bujur && !lintang) return

          const longitude = Number(bujur)
          const latitude = Number(lintang)
          if (!nomor || !namaTitik || !bujur || !lintang || !Number.isFinite(longitude) || !Number.isFinite(latitude)) {
            throw new Error(
              `Data pada baris Excel ${
                index + 2
              } tidak valid. Pastikan No, Nama Titik, Bujur, dan Lintang terisi dengan benar.`,
            )
          }

          importedPoints.push({
            id: this.nextPointId + importedPoints.length,
            nama_titik: namaTitik,
            bujur: longitude,
            lintang: latitude,
          })
        })

        const minimumPoints = this.value.jenis_area === 'Luas' ? 3 : 2
        if (importedPoints.length < minimumPoints) {
          const geometryName = this.value.jenis_area === 'Luas' ? 'polygon' : 'polyline'
          throw new Error(`File Excel harus berisi minimal ${minimumPoints} titik untuk membentuk ${geometryName}.`)
        }

        this.nextPointId += importedPoints.length
        this.$emit('input', { ...this.value, koordinat_perizinan: importedPoints })
        this.showImportModal = false
      } catch (error) {
        this.importError = error.message || 'File Excel gagal dibaca.'
      } finally {
        this.isImporting = false
      }
    },
    getCoordinateColumnIndexes(headerRow) {
      const normalize = (value) =>
        String(value)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '')
      const findIndex = (aliases) => headerRow.findIndex((header) => aliases.includes(normalize(header)))
      return {
        nomor: findIndex(['no', 'nomor']),
        namaTitik: findIndex(['namatitik']),
        bujur: findIndex(['bujur', 'longitude']),
        lintang: findIndex(['lintang', 'latitude']),
      }
    },
    onMapReady(map) {
      this._leafletMap = map
      this.zoomToPolygon()
    },
    zoomToPolygon() {
      if (!this._leafletMap || !this.geometryIsValid) return
      this.$nextTick(() => this._leafletMap.fitBounds(this.polygonLatLngs, { padding: [20, 20] }))
    },
  },
  watch: {
    polygonLatLngs() {
      this.zoomToPolygon()
    },
  },
}
</script>

<style scoped>
.coordinate-map {
  height: 360px;
  width: 100%;
}
</style>
